import { _ } from "../../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import topListOverviewWidget from "./topListOverviewWidget.js";

/**
 * Displays a row consisting of the Top Lists (e.g., "Top month
 * income") displayed in the overview.
 *
 * @param {function} getPeriodType - Returns text describing the kind
 * of period the top lists are displayed for (e.g., `_("month")`).
 */
export default class TopListsOverviewWidget extends Widget {
	constructor({ getPeriodType }) {
		super(...arguments);

		this._incomeWidget = topListOverviewWidget();
		this._profitLossWidget = topListOverviewWidget();

		this._lists = this.constructor
			._topListSpecs()
			.map(({ keyFigureId, titleRenderer }) => ({
				keyFigureId,
				getTitle: () => titleRenderer(getPeriodType()),
				widget: topListOverviewWidget(),
			}));
	}

	show(period, topListData) {
		this._lists.forEach(({ keyFigureId, widget }) => {
			const listData = topListData.find(
				// eslint-disable-next-line no-shadow -- bad practice, we should fix this
				(listData) => listData.keyFigureId === keyFigureId,
			);

			if (listData) {
				widget.show(listData.keyFigure, listData.values, period);
			}
		});

		this.update();
	}

	renderContentOn(html) {
		html.div({ klass: "row" }, this._renderListsOn.bind(this));
	}

	_renderListsOn(html) {
		html.render(this._lists.map((list) => this._topListRenderer(list)));
	}

	_topListRenderer({ getTitle, widget }) {
		return (html) => {
			if (widget.isEmpty()) {
				return;
			}

			html.div(
				{ class: "col-lg-6 col-md-6 col-sm-6" },
				html.h2(getTitle()),
				widget,
			);
		};
	}

	static keyFigureIds() {
		return this._topListSpecs().map(({ keyFigureId }) => keyFigureId);
	}

	static _topListSpecs() {
		return [
			{
				keyFigureId: "IncomeBeforeFinancial",
				titleRenderer: (periodType) =>
					_("Top {periodType} Income", {
						periodType,
					}),
			},
			{
				keyFigureId: "ResultAfterFinancialItems",
				titleRenderer: (periodType) =>
					_("Top {periodType} Profit/Loss", {
						periodType,
					}),
			},
		];
	}
}
